import styled from 'styled-components';

export const SecurityRankCardContainer = styled.div`
	display: flex;
	align-items: center;
	gap: 0.5rem;
	height: 100%;
	border: ${(props) => `1px solid ${props.theme.v3.colors.gray[2]}`};
	border-left: ${(props) => `2px solid ${props.theme.v3.colors.gray[2]}`};
	border-radius: 0.25rem;
	padding: 0.5rem;
	background: ${(props) => `${props.theme.v3.colors.gray[0]}`};

	.pills {
		display: flex;
		gap: 0.25rem;
	}

	.rank-actions {
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		height: 100%;
		margin-left: auto;

		.remove {
			margin-left: auto;
			padding: 0.25rem;
			opacity: 0.6;
			cursor: pointer;

			&:hover {
				opacity: 1;
			}
		}

		.bottom {
			display: flex;
			align-items: center;
			gap: 0.5rem;
			margin-top: auto;
		}

		.split-merge,
		.financial-terms {
			width: 1.5rem;
			height: 1.5rem;
			display: flex;
			align-items: center;
			justify-content: center;
			border-radius: 0.25rem;
			cursor: pointer;
			transition: background 0.15s ease;

			&:hover {
				background: ${(props) => props.theme.v3.colors.gray[2]};
			}
		}
	}

	&.warrant {
		border: ${(props) => `1px dashed ${props.theme.v3.colors.gray[2]}`};
		background: white;
		user-select: none;

		.content {
			opacity: 0.6;
		}
	}
`;
